// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"23260a27","189":"3162369e","240":"742b9606","351":"46f790f6","370":"18ce3024","387":"d99fd21b","444":"934cae47","472":"414bbc4d","575":"48fb05c2","591":"9e6e2b40","663":"81d04b62","787":"5d17ce79","835":"7ad2a96a","886":"1da69a77"}[chunkId] + ".chunk.js";
};